export default __webpack_public_path__ + "f7fcca4b8a5d1043c48b6b2e8b0099f9.svg";